"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHttpErrorMessage = void 0;
const DEFAULT_INTERNAL_ERROR_MESSAGE = "Internal Error";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getHttpErrorMessage = (error) => {
    var _a, _b, _c, _d;
    return ((_d = (_c = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : error.message) !== null && _d !== void 0 ? _d : DEFAULT_INTERNAL_ERROR_MESSAGE);
};
exports.getHttpErrorMessage = getHttpErrorMessage;
